import type { UnaryInterceptor } from 'grpc-web';

function createInterceptor(getAccessToken: () => Promise<string>): UnaryInterceptor<any, any> {
  return {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    async intercept(request, invoker) {
      try {
        const token = await getAccessToken();
        const meta = request.getMetadata();
        meta.Authorization = `Bearer ${token}`;
        return await invoker(request);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        throw error;
      }
    },
  };
}

interface ServiceConstructor {
  new (host: string, n: null, opts: Record<string, any>): any;
}

export class GrpcClient {
  private readonly hostname: string;

  private readonly opts: Record<string, any>;

  constructor(hostname: string, getAccessToken: () => Promise<string>) {
    this.hostname = hostname;
    const interceptor = createInterceptor(getAccessToken);
    const {
      devToolsUnaryInterceptor,
      devToolsStreamInterceptor,
      // eslint-disable-next-line no-underscore-dangle,no-unsafe-optional-chaining
    } = (window as any).__GRPCWEB_DEVTOOLS__?.() ?? {};

    this.opts = {
      unaryInterceptors: [devToolsUnaryInterceptor, interceptor].filter(Boolean),
      streamInterceptors: [devToolsStreamInterceptor].filter(Boolean),
    };
  }

  createServiceClient<T extends ServiceConstructor>(Constr: T): InstanceType<T> {
    return new Constr(this.hostname, null, this.opts);
  }
}
